export default "__VITE_ASSET__CUyeWg96__"